import { Parser } from "json2csv";

function domDownload(filename, text) {
  const element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:text/csv;charset=utf-8," + encodeURIComponent(text)
  );
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function handleExport(data: any[]) {
  try {
    const fields = Object.keys(data[0]);
    const opts = { fields };
    const _parser = new Parser(opts);
    const _csv = _parser.parse(data);
    domDownload(
      `Discovery Data Export - ${new Date().toISOString()}.csv`,
      _csv
    );
  } catch (e) {
    console.log(e);
  }
}
